var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddCross(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.769,
    height: 17.769,
    viewBox: "0 0 17.769 17.769",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icono_agregar",
    d: "M13.961,40.25v1.269a.477.477,0,0,1-.476.476H9.995v3.49a.477.477,0,0,1-.476.476H8.25a.477.477,0,0,1-.476-.476v-3.49H4.283a.477.477,0,0,1-.476-.476V40.25a.477.477,0,0,1,.476-.476h3.49v-3.49a.477.477,0,0,1,.476-.476H9.519a.477.477,0,0,1,.476.476v3.49h3.49A.477.477,0,0,1,13.961,40.25ZM17.769,33.9V47.865a1.9,1.9,0,0,1-1.9,1.9H1.9a1.9,1.9,0,0,1-1.9-1.9V33.9A1.9,1.9,0,0,1,1.9,32H15.865A1.9,1.9,0,0,1,17.769,33.9ZM16.121,48.028V33.9a.239.239,0,0,0-.238-.238H1.823a.239.239,0,0,0-.238.238V48.028a.239.239,0,0,0,.238.238h14.06A.239.239,0,0,0,16.121,48.028Z",
    transform: "translate(0 -32)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddCross);
export default __webpack_public_path__ + "static/media/icon_add_cross.952288ea16d5d6662a517ca48903b6cd.svg";
export { ForwardRef as ReactComponent };